import { ClipboardList } from "lucide-react";
import { fleetrifyIcons } from "../../assets/icons/icons";
import { FLEETRIFYROUTEPATH } from "../../routes/routesPath";
import {
  STAFF_MANAGEMENT_PERMISSIONS,
  ORDER_PERMISSIONS,
  RELOCATION_PERMISSIONS,
  ORDER_MANAGEMENT_PERMISSIONS,
  DASHBOARD_PERMISSIONS,
  MESSAGE_PERMISSIONS,
  FLEET_MANAGEMENT_PERMISSIONS,
} from "../../constants/permissions";

export interface SidebarItem {
  label: string;
  path?: string;
  icon?: any;
  children?: SidebarItem[];
  /** Any one permission in this list grants access. Empty/absent = always visible. */
  permissions?: string[];
  showBell?: boolean;
  /** If set, only users on this exact subscription plan can see this item. */
  planRequired?: string;
}

export const sidebarItems = (
  role: "company" | "individual",
  hasBranch?: boolean
): SidebarItem[] => {
  return [
    {
      label: "Dashboard",
      path: FLEETRIFYROUTEPATH.DASHBOARD,
      icon: fleetrifyIcons.dashboard,
      permissions: DASHBOARD_PERMISSIONS,
    },

    ...(hasBranch
      ? [
          {
            label: "Branch Management",
            path: FLEETRIFYROUTEPATH.BRANCH,
            icon: fleetrifyIcons.company,
            permissions: [
              "create branch",
              "activate branch",
              "deactivate branch",
              "delete branch",
              "edit branch",
            ],
          },
        ]
      : []),

    {
          //  label: "Users",
      label: "User Management",
      icon: fleetrifyIcons.users,
      permissions: STAFF_MANAGEMENT_PERMISSIONS,
      children: [
        {
          label: "Staff",
          path: FLEETRIFYROUTEPATH.USER,
          icon: fleetrifyIcons.users,
          permissions: STAFF_MANAGEMENT_PERMISSIONS,
        },
      ],
    },

    {
      label: "Order Management",
      icon: fleetrifyIcons.order,
      permissions: ORDER_MANAGEMENT_PERMISSIONS,
      children: [
        {
          label: "Orders",
          path: FLEETRIFYROUTEPATH.ORDERS,
          icon: fleetrifyIcons.order,
          showBell: true,
          permissions: ORDER_PERMISSIONS,
        },
        {
          label: "Relocation Requests",
          path: FLEETRIFYROUTEPATH.ORDER_REQUESTS,
          icon: (color: string = "#000") => <ClipboardList size={18} color={color} />,
          showBell: true,
          permissions: RELOCATION_PERMISSIONS,
        },
      ],
    },

    {
      label: "Fleet Management",
      path: FLEETRIFYROUTEPATH.FLEET_MANAGEMENT,
      icon: fleetrifyIcons.fleet,
      permissions: FLEET_MANAGEMENT_PERMISSIONS,
    },

    {
      label: "Message",
      path: FLEETRIFYROUTEPATH.MESSAGE,
      icon: fleetrifyIcons.message,
      permissions: MESSAGE_PERMISSIONS,
    },

    {
      label: "Service Management",
      path: FLEETRIFYROUTEPATH.SERVICES,
      icon: fleetrifyIcons.servicesIcon,
      permissions: ["add services", "update service", "delete service"],
    },

    {
      label: "Wallet",
      path: FLEETRIFYROUTEPATH.WALLET,
      icon: fleetrifyIcons.wallet,
      permissions: [
        "view wallet",
        "access to withdraw",
        "view transaction histories",
        "view wallet settings",
      ],
    },

    {
      label: "AI Insights",
      path: FLEETRIFYROUTEPATH.INSIGHTS,
      icon: fleetrifyIcons.insights,
      planRequired: "Individual Business",
    },
    {
      label: "Setting",
      path: FLEETRIFYROUTEPATH.SETTINGS,
      icon: fleetrifyIcons.settings,
      permissions: [
        "update company profile",
        "update role",
        "create role",
        "delete role",
        "view permissions",
        "update company password",
        "update email notification",
        "update in-app notifications",
      ],
    },
  ];
};
